import React from 'react';
import { Card } from '@tremor/react';
import { useTranslation } from 'react-i18next';
import { usePopup } from '../../contexts/PopupContext';
import { PopularCategoryIcon } from './PopularCategoryIcons';
import { EVENT_CATEGORY_COLORS, EVENT_CATEGORY_ORDER } from '../../config/eventCategoryVisuals';
import './PopularCategories.css';

function PopularCategories({ activeCategory, onCategoryChange }) {
  const { t } = useTranslation('discover');
  const { openPopup } = usePopup();

  const handleCategoryClick = (categoryId) => {
    if (onCategoryChange) {
      onCategoryChange(categoryId);
    }
  };

  const handleCreateClick = () => {
    openPopup('create-event', {}, 0);
  };

  return (
    <Card className="popular-categories-widget">
      <h2 className="widget-title popular-categories-heading">{t('discover.popularCategories.title')}</h2>
      <div className="categories-grid">
        <button
          type="button"
          className={`category-item category-item--show-all ${activeCategory === 'all' ? 'category-item--active' : ''}`}
          onClick={() => handleCategoryClick('all')}
          style={{ '--category-color': EVENT_CATEGORY_COLORS.showAll }}
        >
          <span className="category-item-icon" aria-hidden>
            <PopularCategoryIcon variant="showAll" className="category-item-svg" />
          </span>
          <span className="category-label">{t('discover.popularCategories.showAll')}</span>
        </button>
        {EVENT_CATEGORY_ORDER.map((id) => (
          <button
            key={id}
            type="button"
            className={`category-item ${activeCategory === id ? 'category-item--active' : ''}`}
            onClick={() => handleCategoryClick(id)}
            style={{ '--category-color': EVENT_CATEGORY_COLORS[id] }}
          >
            <span className="category-item-icon" aria-hidden>
              <PopularCategoryIcon variant={id} className="category-item-svg" />
            </span>
            <span className="category-label">{t(`discover.popularCategories.names.${id}`)}</span>
          </button>
        ))}
        <button
          type="button"
          className="category-item category-item--create"
          onClick={handleCreateClick}
        >
          <span className="category-item-icon category-item-icon--create" aria-hidden>
            <PopularCategoryIcon variant="create" className="category-item-svg" />
          </span>
          <span className="category-label category-label--create">
            {t('discover.popularCategories.createTile')}
          </span>
        </button>
      </div>
    </Card>
  );
}

export default PopularCategories;
